import { useState } from "react";
import { connect } from "react-redux";
import Table from "./Table";

function Activities(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const resultList = props.selectedPatient
    ? props.activitiesResults?.filter(
        (a) => a.custid == props.selectedPatient.custid
      )
    : props.activitiesResults;
  const pages = Math.ceil(resultList?.length / 10);

  const toShow = resultList
    ?.sort((b, a) => a.internalcounter - b.internalcounter)
    .slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10);

  return (
    <div>
      <h2>פעילויות</h2>
      <Table
        kind="activities"
        measurment={toShow}
        pages={pages}
        currentPage={currentPage}
        updatePageNumber={(i) => setCurrentPage(i)}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    activitiesResults: state.activitiesResults,
    selectedPatient: state.selectedPatient,
  };
};
export default connect(mapStateToProps)(Activities);
